/* ==========================================================================
   DZ SEGMENTATION — T3: Delivery estimate logic
   ==========================================================================
   Renders: "Order within 2h 14m — estimated arrival by Thu, Aug 20."
   or, after the cutoff / on weekends:
            "Order now — estimated arrival by Fri, Aug 21."

   All times are computed in the store's shipping timezone (America/New_York)
   regardless of the visitor's local timezone, because the 12 PM EST cutoff
   in the shipping policy is an Eastern-time cutoff.

   Config lives on the element (set in snippets/dz-delivery-estimate.liquid):
     data-cutoff-hour      e.g. "12"  (24h clock, Eastern)
     data-processing-days  e.g. "1"   (business days)
     data-transit-days     e.g. "5"   (business days)

   Implemented as a custom element so it re-initializes automatically every
   time the cart drawer re-renders its HTML (Be Yours replaces the drawer's
   innerHTML on cart updates, which re-runs connectedCallback).
   ========================================================================== */
(function () {
  'use strict';
  if (customElements.get('dz-delivery-estimate')) return;

  var NY = 'America/New_York';

  /* Current date/time parts in the shipping timezone. */
  function nyNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: NY,
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false, weekday: 'short'
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return {
      year: +p.year, month: +p.month, day: +p.day,
      hour: +p.hour % 24, minute: +p.minute, weekday: p.weekday
    };
  }

  function isWeekend(d) { var w = d.getUTCDay(); return w === 0 || w === 6; }

  function addBusinessDays(d, n) {
    var out = new Date(d.getTime());
    while (n > 0) {
      out.setUTCDate(out.getUTCDate() + 1);
      if (!isWeekend(out)) n--;
    }
    return out;
  }

  function formatDate(d) {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC'
    }).format(d);
  }

  var DzDeliveryEstimate = function () {
    return Reflect.construct(HTMLElement, [], DzDeliveryEstimate);
  };
  DzDeliveryEstimate.prototype = Object.create(HTMLElement.prototype);
  DzDeliveryEstimate.prototype.constructor = DzDeliveryEstimate;
  Object.setPrototypeOf(DzDeliveryEstimate, HTMLElement);

  DzDeliveryEstimate.prototype.connectedCallback = function () {
    this._textEl = this.querySelector('[data-dz-delivery-text]');
    if (!this._textEl) return;
    this._cutoffHour = parseInt(this.dataset.cutoffHour, 10) || 12;
    this._processing = parseInt(this.dataset.processingDays, 10) || 1;
    this._transit = parseInt(this.dataset.transitDays, 10) || 5;
    this._render();
    /* Refresh the countdown each minute while visible. */
    this._timer = setInterval(this._render.bind(this), 60000);
  };

  DzDeliveryEstimate.prototype.disconnectedCallback = function () {
    if (this._timer) clearInterval(this._timer);
  };

  DzDeliveryEstimate.prototype._render = function () {
    var now = nyNow();
    /* Anchor "today" (Eastern) at UTC noon so business-day math is DST-safe. */
    var today = new Date(Date.UTC(now.year, now.month - 1, now.day, 12));

    var minutesToCutoff = (this._cutoffHour * 60) - (now.hour * 60 + now.minute);
    var beforeCutoff = !isWeekend(today) && minutesToCutoff > 0;

    /* If the cutoff has passed (or it's a weekend), the order effectively
       starts on the next business day. */
    var startDay = beforeCutoff ? today : addBusinessDays(today, 1);
    var arrival = addBusinessDays(startDay, this._processing + this._transit);
    var arrivalText = formatDate(arrival);

    var msg;
    if (beforeCutoff) {
      var h = Math.floor(minutesToCutoff / 60);
      var m = minutesToCutoff % 60;
      var countdown = (h > 0 ? h + 'h ' : '') + m + 'm';
      msg = 'Order within ' + countdown + ' — estimated arrival by ' + arrivalText + '.';
    } else {
      msg = 'Order now — estimated arrival by ' + arrivalText + '.';
    }

    this._textEl.textContent = msg;
    this.removeAttribute('hidden');
  };

  customElements.define('dz-delivery-estimate', DzDeliveryEstimate);
})();
